import FeatureConfigChangeLogTable from "../../../views/FeatureConfigChangeLog";
import Namespace from "../../../views/Namespace";
import FeatureConfig from "../../../views/FeatureConfig";
import MenuNames from "../../../constants/Menu/MenuNames.json";
import BulkUploadFeatureConfig from "../../../views/FeatureConfigBulkUpload";
import BulkDeleteFeatureConfig from "../../../views/FeatureConfigBulkDelete";
import FeatureConfigList from "../../../views/FeatureConfigList";
import ConfigAccessControl from "../../../views/ConfigAccessControl";

const FeatureConfigRoutes = [
  {
    menuName: MenuNames.FEATURE_CONFIG,
    path: "/feature-config/details",
    component: FeatureConfigChangeLogTable,
    exact: true,
  },
  {
    menuName: MenuNames.FEATURE_CONFIG,
    path: "/feature-config/list",
    component: FeatureConfigList,
    exact: true,
  },
  {
    menuName: MenuNames.FEATURE_CONFIG,
    path: "/feature-config/namespaces",
    component: Namespace,
    exact: true,
  },
  {
    menuName: MenuNames.FEATURE_CONFIG,
    path: "/feature-config",
    component: FeatureConfig,
    exact: true,
  },
  {
    menuName: MenuNames.FEATURE_CONFIG,
    path: "/feature-config/bulk-upload",
    component: BulkUploadFeatureConfig,
    exact: true,
  },
  {
    menuName: MenuNames.FEATURE_CONFIG,
    path: "/feature-config/bulk-delete",
    component: BulkDeleteFeatureConfig,
    exact: true,
  },
  {
    menuName: MenuNames.FEATURE_CONFIG,
    path: "/feature-config/access-control",
    component: ConfigAccessControl,
    exact: true,
  },
];

export default FeatureConfigRoutes;
